import { render, staticRenderFns } from "./ManageConfigsClient.vue?vue&type=template&id=aef0abb6&scoped=true"
import script from "./ManageConfigsClient.vue?vue&type=script&lang=ts"
export * from "./ManageConfigsClient.vue?vue&type=script&lang=ts"
import style0 from "./ManageConfigsClient.vue?vue&type=style&index=0&id=aef0abb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef0abb6",
  null
  
)

export default component.exports